import { mixin } from 'class-mixins';
import { ErrorNotifyTrait } from '@goodt-common/shared';

/**
 * @extends {ErrorNotifyTrait}
 */
export class BaseService {
    /**
     * @param {BaseError} error
     */
    handleError(error) {
        if (error.isCancel) {
            return;
        }
        this.notifyError(error);
    }
}

mixin(BaseService, ErrorNotifyTrait);
